export const Device = {
  DESKTOP: 'desktop',
  MOBILE: 'mobile',
};

export enum EFeatureKey {
  SOLOFRIENDLY = 'SOLOFRIENDLY',
  SOLOREQUEST = 'SOLOREQUEST',
  SHARABLE = 'SHARABLE',
  GROUPONLY = 'GROUPONLY',
  PRIVATE = 'PRIVATE',
  HIGHEND = 'HIGHEND',
  LUX = 'LUX',
  MIDLUX = 'MIDLUX',
  BUDGETFRIENDLY = 'BUDGETFRIENDLY',
  STARTWHENEVER = 'STARTWHENEVER',
  EXCLUSIVEDATES = 'EXCLUSIVEDATES',
  CUSTOMIZE = 'CUSTOMIZE',
}
